export default __webpack_public_path__ + "static/media/thousandfell.247c82c5.jpg";